import { Checkbox as CheckboxPrimitive } from "@base-ui-components/react/checkbox";
import { Check } from "lucide-react";
import * as React from "react";
import { cn } from "../lib/utils";

// #738: Base UI の Checkbox.Root は <span> を描画する (旧 radix は <button> だった)。
// span は既定で display:inline なので、display を上書きしないと h-4 w-4 が効かず
// 左右のボーダーだけが残った幅 2px の縦線になる。無効状態も :disabled ではなく
// data-disabled 属性で表現されるため、見た目の指定は data-[disabled] で書く。
const Checkbox = React.forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50 data-[checked]:bg-primary data-[checked]:text-primary-foreground",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = "Checkbox";

export { Checkbox };
